import HeroSection from './HeroSection';
import Inspire from './Inspire';
import {
  Audiences, Faq, FinalCta, HowItWorks, Impact, Inclusion, Investors, Journey, Problem, Proof,
  Solution, Solutions, Story, Technology, Traction, Vision,
} from './Sections';

export default function HomePage() {
  return (
    <>
      <HeroSection />
      <Traction />
      <Problem />
      <Solution />
      <HowItWorks />
      <Solutions />
      <Inspire />
      <Journey />
      <Inclusion />
      <Impact />
      <Technology />
      <Story />
      <Vision />
      <Audiences />
      <Investors />
      <Proof />
      <Faq />
      <FinalCta />
    </>
  );
}
